export interface IUserRole {
  id: string;
  name: string;
  dealerChoice: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  isRegional?: boolean;
  isLeaderRegional?: boolean;
}

export interface IUser {
  id: number;
  fullName: string;
  login: string;
  position: string;
  phone: string;
  email: string;
  status: string;
  dealerChoice: string;
  role: IUserRole;
  lastOnline: string;
  createdAt: string;
  isAnnouncementsAccess: boolean;
  isAnnouncementsSend: boolean;
}

export interface IUserMe {
  user: IUser;
}

export enum orderDirectionIProps {
  desc = "desc",
  asc = "asc",
}

export interface userListFilterIProps {
  page?: number;
  count?: number;
  id?: number;
  fullName?: string;
  searchText?: string;
  login?: string;
  position?: string;
  email?: string;
  phone?: string;
  // ID дилерских центров
  dealerIds?: number[];
  // Названия ролей
  roleNames?: string[];
  // Права/доступы пользователя (OR-логика: хотя бы одно право)
  permissionIds?: string[];
  // ID подразделений
  subdivisionIds?: number[];
  status?: string;
  statuses?: string[];
  orderBy?:
    | "id"
    | "fullName"
    | "login"
    | "position"
    | "email"
    | "phone"
    | "role"
    | "status"
    | "dealerCount"
    | "lastOnline"
    | "isAnnouncementsSend"
    | "isAnnouncementsAccess";
  orderDirection?: orderDirectionIProps;
  // export: true — вместо списка сервер вернёт ссылку на Excel-файл
  export?: boolean;
}

// POST /user/list с export: true — ссылка на выгрузку реестра пользователей
export interface IUserListExportResponse {
  link: string;
}

export type UserListFormFilter = Pick<
  userListFilterIProps,
  | "id"
  | "fullName"
  | "searchText"
  | "login"
  | "position"
  | "email"
  | "phone"
  | "dealerIds"
  | "roleNames"
  | "permissionIds"
  | "subdivisionIds"
  | "status"
  | "statuses"
>;

export interface UserListIProps {
  items: IUser[];
  total: number;
}

export interface IMigrateToStaffResponse {
  success: boolean;
  message: string;
  totalProcessed: number;
  totalSuccess: number;
  totalSkipped: number;
  totalErrors: number;
}

// GET /dealer/employees — плоский список активных сотрудников ДЦ (PASDILER-2096)
export interface IDealerEmployee {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  roleName: string;
}

export interface ISubdivision {
  id: number;
  name: string;
  code: string;
}
export interface IDealerProfile {
  id: number;
  dealerName: string;
}
export interface IUserProfile {
  id: number;
  fullName: string;
  phone: string;
  position: string;
  oldRole: string;
  subdivisionId: number | null;
  email: string;
  login: string;
  roleId: string;
  status: string;
  lockDate: string | null;
  dealerChoice: string;

  role: IUserRole | null;
  subdivision: ISubdivision | null;
  dealers: IDealerProfile[];
}
export interface IUserResponse {
  user: IUserProfile;
}
